import React from "react";

const BAR_HEIGHTS = [35, 65, 100, 55, 80, 45, 90, 60];

/**
 * Animated bar-chart style loading indicator (used in place of a static spinner gif).
 * Props:
 *   label - optional caption text (default: "Loading visual…")
 */
const BarChartLoader = ({ label = "Loading visual…" }) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: "14px",
    }}
  >
    <style>{`
      @keyframes barChartLoaderPulse {
        0%, 100% { transform: scaleY(0.35); opacity: 0.55; }
        50% { transform: scaleY(1); opacity: 1; }
      }
    `}</style>
    <div style={{ display: "flex", alignItems: "flex-end", gap: 6, height: 70 }}>
      {BAR_HEIGHTS.map((h, i) => (
        <div
          key={i}
          style={{
            width: 10,
            height: `${h}%`,
            borderRadius: 3,
            transformOrigin: "bottom",
            background: "var(--app-ai-assistant-gradient, linear-gradient(135deg,#253978,#1a2a5e))",
            animation: `barChartLoaderPulse 1.1s ease-in-out ${i * 0.1}s infinite`,
          }}
        />
      ))}
    </div>
    {label && <span style={{ fontSize: 12, color: "#9ca3af", fontWeight: 500 }}>{label}</span>}
  </div>
);

export default BarChartLoader;
